const routes = [
    {
      name: 'channel',
      path: '/channel',
      component: () => import('../../pages/channel/index.vue'),
      children: [
        {
            name: 'channelConfirm',
            path: 'confirm',
            component: () => import('../../pages/channel/confirm.vue'),
          },
        {
          name: 'channelCode',
          path: 'code',
          component: () => import('../../pages/channel/code'),
        },
        {
          name: 'channelPhone',
          path: 'phone',
          component: () => import('../../pages/channel/phone'),
        },
        {
          name: 'channelRegister',
          path: 'register',
          component: () => import('../../pages/channel/register'),
        }
      ]
    },
  
  ];
  
  export default routes;
  